import { ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, HostListener, Input, OnInit, Output, Type, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationExtras, NavigationStart, Router } from '@angular/router';

import { alert, confirm, custom } from 'devextreme/ui/dialog';

import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { NicaMapsComponent } from '../../widgets/nica-maps/nica-maps.component';


import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { NicaFiltroComponent } from '../../components/shared/nica-filtro/nica-filtro.component';
import notify from 'devextreme/ui/notify';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-cantiere',
  templateUrl: './magazzino.component.html',
  styleUrls: ['./magazzino.component.css', '../../views/ana-soggetto/ana-soggetto.component.css']
})
export class MagazzinoComponent extends NicaMaster implements OnInit {

  @Input() idSoggetto: {};
  @Input() itemData
  apiset: string;
  SubjectCall: string;
  filter: string;
  datiFormulario: any[]
  cssClass: string = ''

  buttonToolbarBottomGrid: any[];


  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,
    private changeDetector: ChangeDetectorRef

  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );
  }


  ngOnInit() {

    

    if (this.itemData != undefined) {

      this.setGlobalVariable(this.itemData);

      this.setFiltroOnInit();

    } else {

      this.activatedroute.queryParams
        .subscribe(params => {
          this.currentTabId = params.currentTabId,
            this.currentTabName = params.currentTabName


          this.showToolBar = false//Per ora ...

          this.setGlobalVariableFromParams(params);

          console.warn('PARAMSSSS',params)

          if(params.service !== 'sede') {

            this.isAdvancedXlsExportAvailable = false;
            this.allowedAdvancedFilter=false;


          }
          else{
            this.isAdvancedXlsExportAvailable = true;
            this.allowedAdvancedFilter=true;
            this.setFiltroOnInit();
          }


        });

    }

    this.buttonToolbarBottomGrid = [


      {
        id: 1,
        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        useSubmitBehavior: true,
        template: false,
        options:
        {
          stylingMode: "text",
          text: 'Fine',
          icon: "glyphicon icon-annulla-form",
          visible: true,
          onClick: ($event) => {


            //this.emettiChiusuraCaption('close');

            this.returnPrevUrl()
          },


        }


      },




    ]




    if (this.SubjectCall == 'sede' && this.template == 'grid') {



      this.pulsantiOpzionaliSede = [

        {
          location: 'before',
          cssClass: 'filter-sede-title toolbar-label',
          isTemplateText: true,
          options: {
            icon: '',
            text: "Filtra l'elenco per tipo attività:",
            class: 'form-control-plaintext',
            stylingMode: 'text',

          }
        },
        {
          location: 'before',
          cssClass: 'filter-sede',
          options: {
            icon: '',
            text: 'Produttore',
            class: 'badge bg-produttore',
            stylingMode: 'text',
            index: 1

          }
        },
        {
          location: 'before',
          cssClass: 'filter-sede',
          options: {
            icon: '',
            text: 'Trasportatore',
            class: 'badge bg-trasportatore',
            stylingMode: 'text',
            index: 2

          }
        },
        {
          location: 'before',
          cssClass: 'filter-sede',
          options: {
            icon: '',
            text: 'Destinatario',
            class: 'badge bg-destinatario',
            stylingMode: 'text',
            index: 3
          }
        },
        {
          location: 'before',
          cssClass: 'filter-sede',
          options: {
            icon: '',
            text: 'Intermediario',
            class: 'badge bg-intermediario',
            stylingMode: 'text',
            index: 4
          }
        },
        {
          location: 'before',
          cssClass: 'filter-sede',
          options: {
            icon: '',
            text: 'Elimina filtro attivo',
            class: 'badge bg-clear-filter',
            stylingMode: 'text',
            index: 5,

          }
        },
      ]
    }


    if (this.SubjectCall == 'magazzinorifiuti' && this.template == 'form') {

      this.cssClass = 'magazzino-form'

    }



    

  }


  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();

  }

  setGlobalVariable(itemData) {

    this.apiset = itemData[0].apiset;
    this.id = itemData[0].id;
    this.queryString = itemData[0].queryString
    this.rowData = itemData[0].dati
    this.template = itemData[0].template
    this.masterKey = itemData[0].masterKey
    this.type = itemData[0].tipo
    this.SubjectCall = itemData[0].SubjectCall;
    this.InviaA = itemData[0].inviaA;
    this.toolbarComponentFilter = itemData[0].toolbarComponent


  }


  setFiltroOnInit() {
    if(!this.allowedAdvancedFilter){
      return
    }
    let filtriOBJ: Object = JSON.parse(localStorage.getItem('Filtri'));


  
  }

  optionalButtonClickToolBar(event) {

    
  }







  formEvent(e) {


    if (e.name == 'ValueChangedLista') {
      console.log("IN ANA-UL.COMPONENTS ", e)
      if (e.campo.dataField == 'stato' && this.SubjectCall == 'sede') {
        if (e.value != 'IT') {
          e.component.itemOption('datiUL.comune', 'validationRules', null)
          // e.component.itemOption('datiUL.comune', 'readOnly', false)
          e.component.itemOption('datiUL.siglaProvincia', 'validationRules', null);
          e.component.itemOption('datiUL.cap', 'validationRules', null);
          e.component.updateData('istatComune', null);
          //e.component.updateData('comune', null)
          e.component.updateData('siglaProvincia', null);
          e.component.updateData('cap', null);

        } else {


          let validationRules = [{
            type: 'required',
            message: 'Campo Obbligatorio'
          }]

          e.component.itemOption('datiUL.comune', 'validationRules', validationRules)
          e.component.itemOption('datiUL.siglaProvincia', 'validationRules', validationRules);
          e.component.itemOption('datiUL.cap', 'validationRules', validationRules);
          e.component.itemOption('datiUL.comune', 'readOnly', true)

          const comune = this.formSoggetto.formEdit.formData.comune

          if (comune != '') {
            const filter = `?$filter=( descrizione eq '${comune}' )`;
            this.anagraficaService.getElenco('comune', '', filter).then(res => {
              let items = res['items'][0]
              e.component.updateData('istatComune', items.id);
            })
          }

        }
      }

      if (e.campo.dataField == 'stato' && this.SubjectCall == 'cantiere') {
        if (e.value != 'IT') {
          e.component.itemOption('datiCantiere.comune', 'validationRules', null)
          // e.component.itemOption('datiUL.comune', 'readOnly', false)
          e.component.itemOption('datiCantiere.provincia', 'validationRules', null);
          e.component.itemOption('datiCantiere.cap', 'validationRules', null);
          e.component.updateData('istatComune', null);
          //e.component.updateData('comune', null)
          e.component.updateData('provincia', null);
          e.component.updateData('cap', null);

        } else {


          let validationRules = [{
            type: 'required',
            message: 'Campo Obbligatorio'
          }]

          e.component.itemOption('datiCantiere.comune', 'validationRules', validationRules)
          e.component.itemOption('datiCantiere.provincia', 'validationRules', validationRules);
          e.component.itemOption('datiCantiere.cap', 'validationRules', validationRules);
          e.component.itemOption('datiCantiere.comune', 'readOnly', true)

          const comune = this.formSoggetto.formEdit.formData.comune

          if (comune != '') {
            const filter = `?$filter=( descrizione eq '${comune}' )`;
            this.anagraficaService.getElenco('comune', '', filter).then(res => {
              let items = res['items'][0]
              e.component.updateData('istatComune', items.id);
            })
          }

        }
      }

      if (e.campo.dataField == 'siglaProvincia') {
        this.anagraficaService.getElenco('Regione', '', '').then(Reg => {
          let returnReg = []
          if (Reg) {
            for (let x in Reg) {
              let arrayProv = Reg[x]['elencoProvincie'].split(',')
              Reg[x]['arrayProv'] = arrayProv
              const resReg = Reg[x]['arrayProv'].filter(prov => prov == e.value)
              if (resReg.length > 0) {
                returnReg.push(Reg[x])
              }

            }


            this.formSoggetto.formRefreshInputData('idRegione', returnReg[0]['id'])
          }
        })
      }

    }

    //dataChiusuraImpiantoMobile
    //isImpiantoMobile
    if (e.evento == 'setTrueImpiantoMobile') {
      const editorDest = e.masterComponent.getEditor('dataChiusuraImpiantoMobile');
      editorDest.option('disabled', !e.event.value);
      editorDest.option('value', null);
      //e.masterComponent.itemOption('altreConfUl.dataChiusuraImpiantoMobile','disabled',!e.event.value)
    }

    if (e.evento == 'setTrueTrasportatore') {


      // Tipo Vettore


      const editorDest = e.masterComponent.getEditor('tipoTrasporto');
      const tipoTrasporto = this.formSoggetto.formEdit.formData.tipoTrasporto
      if (e.event.value) {
        editorDest.option('disabled', false);

        if (tipoTrasporto) {
          this.formSoggetto.formRefreshInputData('tipoTrasporto', tipoTrasporto)
        } else {
          this.formSoggetto.formRefreshInputData('tipoTrasporto', "1")
        }

      } else {
        editorDest.option('disabled', true);

        editorDest.option('value', null);
      }





      const formData = this.formSoggetto.formEdit.formData
      const event = e.event;
      if (event.value) {
        let validationRules = [{
          type: 'required',
          message: 'N.Autorizzazione obbligatorio'
        }]

        //e.masterComponent.itemOption('datiUL.numeroIscrizioneAlbo','validationRules', validationRules)
      } else if (!formData.isProduttore && !formData.isIntermediario) {


        //e.masterComponent.itemOption('datiUL.numeroIscrizioneAlbo','validationRules', null)
      }





    }

    if (e.evento == 'setTrueIntermediario') {

      const formData = this.formSoggetto.formEdit.formData
      const event = e.event;
      if (event.value) {
        let validationRules = [{
          type: 'required',
          message: 'N.Autorizzazione obbligatorio'
        }]

        //e.masterComponent.itemOption('datiUL.numeroIscrizioneAlbo','validationRules', validationRules)
      } else if (!formData.isProduttore && !formData.isTrasportatore) {


        //e.masterComponent.itemOption('datiUL.numeroIscrizioneAlbo','validationRules', null)
      }




    }

    if (e.evento == 'setTrueDestinatario' && e.riferimento.dataField == 'isProduttore') {

      console.log('setTrueDestinatario', e.event)
      const formData = this.formSoggetto.formEdit.formData
      const event = e.event;
      if (event.value) {
        let validationRules = [{
          type: 'required',
          message: 'N.Autorizzazione obbligatorio'
        }]

        //e.masterComponent.itemOption('datiUL.numeroIscrizioneAlbo','validationRules', validationRules)
      } else if (!formData.isTrasportatore && !formData.isIntermediario) {


        //e.masterComponent.itemOption('datiUL.numeroIscrizioneAlbo','validationRules', null)
      }

    }

    if (e.evento == 'setTrueProduttore') {
      //console.log(e)
      if (this.filterID['nsAzienda']) {
        if (e.riferimento.dataField == 'isSmaltitore') {
          const editorDest = e.masterComponent.getEditor('isProduttore');
          let value = editorDest.option('value');
          if (e.event.value) {
            editorDest.option('value', e.event.value);
          } else {
            const editorSmaltitore = e.masterComponent.getEditor('isSmaltitore');
            editorSmaltitore.option('value', false);
            this.formSoggetto.formRefreshInputData('isSmaltitore', false);

            const editorProduttore = e.masterComponent.getEditor('isProduttore');

            editorProduttore.option('value', false);
          }


          ////console.log('value',value)

        }

      }


    }

    if (e.evento == 'showDepositoConou') {

      e.masterComponent.itemOption('altreConfUl.codiceConou', 'visible', e.event.value)
      if (e.event.value) {
        e.masterComponent.itemOption('altreConfUl.codiceConou', 'colSpan', '')
        e.masterComponent.itemOption('altreConfUl.codiceConou', 'colSpan', '')
      } else {
        //e.masterComponent.itemOption('altreConfUl.depositoConou','colSpan',2)
        e.masterComponent.itemOption('altreConfUl.codiceConou', 'colSpan', 2)
      }


    }

    if (e.name == 'ottieniCoordinate') {


      if (this.formSoggetto.formEdit.formData['latidudine'] < -90 || this.formSoggetto.formEdit.formData['latidudine'] > 90) {
        alert('Per la latitudine specificare un numero compreso tra -90 e 90', 'Attenzione');
        return;
      }

      if (this.formSoggetto.formEdit.formData['longitudine'] < -180 || this.formSoggetto.formEdit.formData['longitudine'] > 180) {
        alert('Per la longitudine specificare un numero compreso tra -180 e 180', 'Attenzione');
        return;
      }




      let address = e.data.indirizzo.concat(' ' + e.data.civico) + ',' + e.data.cap + ' ' + e.data.comune + ' ' + e.data.siglaProvincia
      this._overlaySidePanelService.setTitle("Coordinate Geografiche");
      let data = [
        {
          destComponent: 'AnaSoggetto',
          traceMessage: 'ottieniCoordinate',
          dati: (e.data.latidudine && e.data.longitudine) ? { lat: e.data.latidudine, lng: e.data.longitudine, address: address } : address
        }
      ]
      this._overlaySidePanelService.setTitle("Ottieni Coordinate");
      this._overlaySidePanelService.sendDataToComponent(data);

      this._overlaySidePanelService.setToolBarVisible(false)

      this._overlaySidePanelService.setContent(NicaMapsComponent);
      this._overlaySideFormService.setPopupWidth(850);
      this._overlaySideFormService.setPopupHeight(870);
      setTimeout(() => {

        (this._overlaySideFormService._hrefComponent.instance.coordinateEmitter as EventEmitter<any>).subscribe(
          (coordinate) => {

            //console.warn(this.anagraficaDati);

            if (coordinate) {
              this.formSoggetto.formEdit.instance.updateData('latidudine', "" + coordinate.lat());
              this.formSoggetto.formEdit.instance.updateData('longitudine', "" + coordinate.lng());
              this._overlaySideFormService.close();
            }
            else if(typeof coordinate == "undefined")
              this._overlaySideFormService.close();
          }

        )

      }, 300);
      this._overlaySidePanelService.show();

    }




    if (e.event == 'copiaDatiAzienda') {

      const icon = e.component.option('icon');

      if (icon == 'glyphicon mdi mdi mdi-checkbox-marked') {
        this.formSoggetto.formEdit.instance.updateData('descrizione', '');
        this.formSoggetto.formEdit.instance.updateData('indirizzo', '');
        this.formSoggetto.formEdit.instance.updateData('civico', '');
        this.formSoggetto.formEdit.instance.updateData('comune', '');
        this.formSoggetto.formEdit.instance.updateData('istatComune', '');
        this.formSoggetto.formEdit.instance.updateData('cap', '');
        this.formSoggetto.formEdit.instance.updateData('siglaProvincia', '');
        this.formSoggetto.formEdit.instance.updateData('stato', '');

        e.component.option('icon', 'glyphicon mdi mdi-checkbox-blank-outline');
        return
      } else {
        const data = e.data
        let filter = data['idSoggetto']

        this.anagraficaService.getValue('soggetto', filter, '').then(res => {

          this.formSoggetto.formEdit.instance.updateData('descrizione', res['ragioneSociale']);
          this.formSoggetto.formEdit.instance.updateData('indirizzo', res['indirizzo']);
          this.formSoggetto.formEdit.instance.updateData('civico', res['civico']);
          this.formSoggetto.formEdit.instance.updateData('comune', res['comune']);
          this.formSoggetto.formEdit.instance.updateData('istatComune', res['istatComune']);
          this.formSoggetto.formEdit.instance.updateData('cap', res['cap']);
          this.formSoggetto.formEdit.instance.updateData('siglaProvincia', res['siglaProvincia']);
          this.formSoggetto.formEdit.instance.updateData('stato', res['stato']);

          e.component.option('icon', 'glyphicon mdi mdi mdi-checkbox-marked')
        })
        return
      }


    }


    if (e.name == 'formDataInit') {

      this.currentElement = e.formData
      if (e.formData.magazzinoRifiutiCer) {
        const magazzinoRifiutiCer = e.formData.magazzinoRifiutiCer.filter(res =>
          res.cer != null
        )
        this.formSoggetto.formRefreshInputData('magazzinoRifiutiCer', magazzinoRifiutiCer)
      }
      if (this.SubjectCall == 'sede') {
        const editorDest = this.formSoggetto.formEdit.instance.getEditor('dataChiusuraImpiantoMobile');
        editorDest.option('disabled', !this.currentElement['isImpiantoMobile']);
        if (!this.currentElement['isImpiantoMobile']) {
          editorDest.option('value', null);


          const editorDest1 = this.formSoggetto.formEdit.instance.getEditor('tipoTrasporto');
          editorDest1.option('disabled', !this.currentElement['isTrasportatore']);
          if (!this.currentElement['isTrasportatore'])
            editorDest1.option('value', null);

        }
      }





    }
    if (e.name == 'allineaRentri') {

      this.rentriService.loginRentriSede(this.id).then(res => {

        if (res) {
          let titleDynamic = "Unità locali R.E.N.T.Ri"


          let componentData = {
            type: 'campoSpecial',
            dataField: "idSedeRentri",
            dynamic: {
              dataSource: "RentriOld/getStruttureElenco",
              service: "serviceRentriSede",
              valueExpr: 'identificativo',
              displayExpr: '',
              queryString: '',
              filter: '',
              componentType: 'dynamicGrid',
              enableEditor: false,
              buttonOption: {
                event: ''
              },
              caption: 'Elenco strutture R.E.N.T.R.i',
              settingGrid: {
                campoTabRif: '', // in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio
                masterKey: 'identificativo',
                keyUnique: 'identificativo',
                selectionMode: 'single',
                rowAlternationEnabled: true,
                repaintChangesOnly: false,
                remoteOperations: true,
                hoverStateEnabled: true,
                allowUpdating: false,
                allowDeleting: false,
                allowAdding: false,
                searchAndSelect: false,
                searchAndSelectDataSource: '',
                height: 450
              }




            }
          }

          this.formSoggetto.eventmitter(componentData, e.event, 'dynamicGrid', 'RentriOld/getStruttureElenco', titleDynamic)
        } else {

          alert('Nessuna Configurazione', 'Attenzione!')
        }
      })

    }

    if (e.name == 'returnButton') {
      e.component.option('text', "Ritorna all'elenco")
    }

    if (e.name == 'formContentInitializzed') {
      this.SetToolbarButtons(this.serviceButtonsArray)

      e.component.itemOption('altreConfUl.iscrittoConou', 'visible', this.filterID['nsAzienda'] ? true : false)
      e.component.itemOption('altreConfUl.iscrittoCobat', 'visible', this.filterID['nsAzienda'] ? true : false)
      e.component.itemOption('altreConfUl.isImpiantoMobile', 'visible', this.filterID['nsAzienda'] ? true : false)
      e.component.itemOption('altreConfUl.dataChiusuraImpiantoMobile', 'visible', this.filterID['nsAzienda'] ? true : false)



    }

    if (e.name == 'return') {

      let data = [];

      /**Gestisco i queryurl Filtri in Base al filtri iniziali**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {

        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        let data = this.formSoggetto.dataSet
        //let data = this.filterID
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            //this.filterID[idTab['key']]=data[idTab['value']]
            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;


          }
        });
        if (this.SubjectCall == 'sede') {
          delete this.filterID['descrizioneSede']
        }


      }

      if (this.SubjectCall == 'sede') {
        this.userComponentService.removeAllItemComponentFromID('sede', this.currentTabId)
      }



      this.refreshPage('', 'Elenco', this.SubjectCall, 'grid');
      return

    }

    if (e.eventName == 'submittedInsertOk') {


      this.id = e[this.masterKey];

      let data = e
      /**Gestisco i queryurl Filtri in Base al Edit**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });



      }

      if (this.SubjectCall == 'soggetto') {
        this.refreshPage(e, 'Modifica', this.SubjectCall, 'form');

        const customMessage = custom({
          title: "Attenzione!",
          messageHtml: "Anagrafica soggetto salvata, inserisci l'unica locale...",

        })

        customMessage.show()

        setTimeout(() => {

          this.refreshPage([], 'Inserisci', 'sede', 'form');
          customMessage.hide()
        }, 1500);


        return


      }

      if (this.SubjectCall != 'sede') {

        let e = {
          name: 'return'
        }

        this.formEvent(e);
        return;
      }


      this.refreshPage(e, 'Modifica', this.SubjectCall, 'form');
      return


    }

    if (e.eventName == 'submittedEditOk') {


      let data = this.formSoggetto.dataSet;

      /**Gestisco i queryurl Filtri in Base al Edit**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {

          if (typeof data[idTab['value']] != 'undefined') {

            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });



      }


      if (this.SubjectCall != 'sede') {

        let e = {
          name: 'return'
        }

        this.formEvent(e);
        return;
      }

      this.refreshPage(data, 'Modifica', this.SubjectCall, 'form');
      return



    }
  }




  /*
  if (e.name == "onContentReady" && e.componentName == 'sede') {


    let items = e.component.getDataSource().items();

    let newData = items.forEach((itm, i) => {
      if (itm.items) {

        itm.items.map((ppp, c) => {
          let tipoAttivita = []
          if (ppp.isProduttore) {
            tipoAttivita.push(
              {
                class: 'produttore-bg me-1',
                value: 'Prod.'
              }
            )

          }
          if (ppp.isTrasportatore) {

            tipoAttivita.push(

              {
                class: 'trasportatore-bg me-1',
                value: 'Trasp.'
              }

            )

          }

          if (ppp.isSmaltitore) {

            tipoAttivita.push(
              {
                class: 'destinatario-bg me-1',
                value: 'Dest.'
              }
            )

          }

          if (ppp.isIntermediario) {

            tipoAttivita.push({
              class: 'intermediario-bg ',
              value: 'Inter.'
            })

          }

          ppp.tipoAttivita = tipoAttivita
        })

      }
    });


    e.component.customizeColumns = (col) => {
      //console.log('customizeColumns', col)
    };


    

  }
*/



  onShowing(e) {
    //////console.log('eventooooo',e);

    //this.showEdit = true;
    e.component.content().parentNode.classList.add("bg-grey"); //add class to overlay content
    e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    //e.component.content().parentNode.classList.add("popup"); //add class to overlay content
    e.component.content().classList.add("soggetto-form"); //add class to content

    //<div class="dx-item-content dx-box-item-content" style="width: auto; height: auto; display: flex; flex-basis: 0px; flex-grow: 1; flex-direction: column;"></div>
    //soggetto-form
    setTimeout(() => {
      var tt = $(".soggetto-form").find(".dx-item .dx-box-item");
      //var tt=$(".dx-item-content .dx-box-item-content");
      //tt[tt.length-1].remove();
      //console.log("ecco le classi ",tt);

    }, 200);

    //$( ".hello" ).remove();
    /*
    if(this.formEditingPopup !== undefined)
      this.formEditingPopup.visible=true;
    */
  }


  appToolBarEvent(evt) {

    console.warn(evt);
  }

}
